"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RoyalParksSpotlighting_exports = {};
__export(RoyalParksSpotlighting_exports, {
  RoyalParksSpotlighting: () => RoyalParksSpotlighting
});
module.exports = __toCommonJS(RoyalParksSpotlighting_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_geometry = require("@cartographerio/geometry");
var import_types = require("@cartographerio/types");
var import_core = require("../../core/index.js");
const RoyalParksSpotlighting = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_types.unsafeMapId)("RoyalParksSpotlighting"),
  title: "Regents Parks Spotlighting",
  defaultBase: import_types.MapBaseEnum.Satellite,
  defaultViewport: { center: (0, import_geometry.point)(-0.16, 51.53), zoom: 14 },
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("RoyalParksSpotlighting"),
      title: "Spotlighting",
      source: (0, import_topo_map.remoteTileSource)({
        url: "mapbox://cartographerio.royal_parks_spotlighting",
        sourceLayer: "spotlighting",
        attribution: [
          (0, import_topo_map.standardAttribution)({
            what: "Hedgehog Data",
            who: "Royal Parks Foundation",
            url: "https://www.royalparks.org.uk/managing-the-parks/conservation-and-improvement-projects/hedgehogs",
            from: "2014"
          })
        ]
      }),
      defaultAttribute: "sex",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Hedgehog Details",
          attributes: [
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "sex",
              label: "Sex",
              buckets: [
                (0, import_topo_map.lookupBucket)("male", import_topo_map.marker.fromColor("#00ccff"), "Male"),
                (0, import_topo_map.lookupBucket)("female", import_topo_map.marker.fromColor("#ff5555"), "Female"),
                (0, import_topo_map.lookupBucket)("unknown", import_topo_map.marker.fromColor("#cccccc"), "Unknown")
              ]
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "age",
              label: "Age",
              buckets: [
                (0, import_topo_map.lookupBucket)("juvenile", import_topo_map.marker.fromColor("#cc5500"), "Juvenile"),
                (0, import_topo_map.lookupBucket)("subadult", import_topo_map.marker.fromColor("#ee8800"), "Subadult"),
                (0, import_topo_map.lookupBucket)("adult", import_topo_map.marker.fromColor("#ffcc00"), "Adult")
              ]
            }),
            (0, import_topo_map.thresholdAttr)({
              attributeId: "weight",
              label: "Weight",
              unit: "g",
              showDistribution: false,
              showTimeline: false,
              buckets: [
                (0, import_topo_map.thresholdBucket)(200, import_topo_map.marker.numeric(0)),
                (0, import_topo_map.thresholdBucket)(400, import_topo_map.marker.numeric(0.1)),
                (0, import_topo_map.thresholdBucket)(600, import_topo_map.marker.numeric(0.2)),
                (0, import_topo_map.thresholdBucket)(800, import_topo_map.marker.numeric(0.4)),
                (0, import_topo_map.thresholdBucket)(1e3, import_topo_map.marker.numeric(0.6)),
                (0, import_topo_map.thresholdBucket)(1200, import_topo_map.marker.numeric(0.8)),
                (0, import_topo_map.thresholdBucket)(1400, import_topo_map.marker.numeric(1))
              ]
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  RoyalParksSpotlighting
});
//# sourceMappingURL=RoyalParksSpotlighting.js.map
